import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ValidatorEditorBase } from '../validator-editor-base/validator-editor-base';

@Component({
  selector: 'df-digital-range-validator-editor',
  templateUrl: './digital-range-validator-editor.component.html',
  styleUrls: ['./digital-range-validator-editor.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DigitalRangeValidatorEditorComponent extends ValidatorEditorBase<any> implements OnInit {
  get min(): number {
    return this._min;
  }
  set min(val: number) {
    this.setMinValue(val);
  }

  get max(): number {
    return this._max;
  }
  set max(val: number) {
    this.setMaxValue(val);
  }

  private _min: number;
  private _max: number;

  regexp: RegExp = /[^(-?\d+)|\.]/gi;

  ngOnInit() {
    if (!this.caption) {
      this.caption = 'æ°å¼èå´';
    }
  }

  setMinValue(val: any) {
    // å¤æ­å°äºå³ä¾§
    this._min = val;
    if (this.control && this.model) {
      this.model.data.min = val;
      this.emitModelChange();
    }
  }

  setMaxValue(val: number) {
    this._max = val;
    if (this.control && this.model) {
      this.model.data.max = val;
      this.emitModelChange();
    }
  }

  minBlur() {
    if (this.min == null) {
      this.min = undefined;
    }
    if (this.max !== undefined) {
      if (this.min > this.max) {
        this.min = this.max;
      }
    }
  }
  maxBlur() {
    if (this.max == null) {
      this.max = undefined;
    }
    // å¤æ­å¤§äºå³ä¾§
    if (this.max !== undefined) {
      if (this.max < this.min) {
        this.max = this.min;
      }
    }
  }

  afterModelInit() {
    this._min = this.model.data.min;
    this._max = this.model.data.max;
  }

  defaultModelData(): any {
    return { min: undefined, max: undefined };
  }
}
